import { ParsedUrlQuery } from 'querystring';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { QueryClient } from '@tanstack/react-query';
import type {
  GetStaticProps,
  GetStaticPaths,
  InferGetStaticPropsType,
  GetStaticPathsResult,
} from 'next';
import Link from 'next/link';

import {
  usePageItem,
  useSetTranslatedSlugs,
} from '@blueprint/core';
import { sharedPageProps } from '@sje-kraken/utils/props';
import {
  HOME_PAGE_SLUG,
  REVALIDATE,
} from '@sje-kraken/app.constants';
import { useSession } from '@krakentech/blueprint-auth';
import { useGlobalMessage } from '@core/components/Providers/GlobalMessage';

type PageProps = {
  slug: string;
};

export default function Page({
  slug,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter();
  const { query } = router;
  const { isAuthenticated } = useSession();
  const { clearGlobalMessage } = useGlobalMessage();

  // Redirect to dashboard if authenticated
  useEffect(() => {
    if (isAuthenticated) {
      if (query.nextPage) {
        router.replace(query.nextPage as string);
      } else {
        router.replace('/dashboard');
      }
    } else {
      router.replace('/login');
    }

    return () => {
      clearGlobalMessage();
    };
  }, [isAuthenticated, router, clearGlobalMessage, query.nextPage]);

  const { data: storyData } = usePageItem({
    id: slug,
  });

  useSetTranslatedSlugs({
    default_full_slug: storyData?.default_full_slug,
    translated_slugs: storyData?.translated_slugs,
  });

  return (
    <div></div>
    // <div style={{ margin: '4rem 2rem' }}>
    //   <h1>Welcome to Blueprint</h1>
    //   <p>Go to <Link href='login'>login</Link> to get started</p>
    // </div>
  );
}

interface PageStaticParams extends ParsedUrlQuery {
  slug: string[];
}

export const getStaticProps: GetStaticProps<
  PageProps,
  PageStaticParams
> = async (context) => {
  const { params, locale, defaultLocale } = context;
  const queryClient = new QueryClient();

  const subslug = params?.slug ? params.slug.join('/') : HOME_PAGE_SLUG;

  // Generate slug for query
  const slug = `${locale === defaultLocale ? '' : locale}/${subslug}`;

  return {
    props: {
      ...(await sharedPageProps({ queryClient, context })),
      slug,
    },
    revalidate: REVALIDATE,
  };
};